import { render, staticRenderFns } from "./PlayerGalleryItemVideo.vue?vue&type=template&id=4c35dddb&scoped=true&"
import script from "./PlayerGalleryItemVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerGalleryItemVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerGalleryItemVideo.vue?vue&type=style&index=0&id=4c35dddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35dddb",
  null
  
)

export default component.exports